import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = createStateReducer(initialState, {
  [events.configureProjectToolsRequested]: setRequestStateToPending,
  [events.configureProjectToolsSucceeded]: setRequestStateToSuccess,
  [events.configureProjectToolsFailed]: setRequestStateToFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
